import { ApplicationCode, IS_ZUS_APPLICATION } from '../enums/application_code';
import { ApplicationFormHistoryEventType } from '../enums/application-form-history-event-type.enum';

export class ApplicationUtils {
  static isFromZus(applicationCode: ApplicationCode) {
    return IS_ZUS_APPLICATION.includes(applicationCode);
  }

  static getApplicationEventTypeLabel(
    eventType: ApplicationFormHistoryEventType,
  ): string {
    switch (eventType) {
      case ApplicationFormHistoryEventType.MODYFIKACJA:
        return 'Modyfikacja';
      default:
        return eventType;
    }
  }
}
